import _ from 'lodash';
import template from './header.html';

class HeaderController {
    constructor(messaging, $state) {
        this.messaging = () => messaging;
        this.$state = () => $state;
    }

    $onInit() {
        this.comments = [];
        this.disableSearch = !_.isString(this.searchPlaceholder);
        this.refreshState();
    }

    refreshState() {
        const messaging = this.messaging();
        messaging.getComments().then(response => {
            this.comments = [...response];
        });
    }

    showComment(comment) {
        const messaging = this.messaging();
        const $state = this.$state();
        messaging.updateComment(comment).then(() => {
            $state.go('radniNalog.details.komentari', { id: comment.radni_nalog });
        });
    }

    submit() {
        this.onSearch({ value: this.searchValue });
    }
}

HeaderController.$inject = ['messaging', '$state'];

const HeaderComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: HeaderController,
    controllerAs: 'vm',
    bindings: {
        onSearch: '&',
        searchPlaceholder: '@'
    }
};

export { HeaderComponent };



// WEBPACK FOOTER //
// ./app/components/common/header/header.component.js